export class KeycloakUserInfoRequestBody {

    userName: String;

}
